import { MainLayout } from 'shared/ui/layout/main';

import { UserTabs } from '../tabs';

export function UserLayout() {
  return <MainLayout tabs={<UserTabs />} />;
}
